<template>
  <Transition appear @before-enter="onBeforeEnter" @enter="onEnter" @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave" @leave="onLeave" @after-leave="onAfterLeave">
    <div v-if="show" class="spo-expand-transition ">
      <slot />
    </div>
  </Transition>
</template>

<script>
const TRANSITION = "height 0.35s cubic-bezier(0.4, 0, 0.2, 1)";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onTransitionEnd(el, done) {
      const handler = (event) => {
        if (event.propertyName !== "height") {
          return;
        }
        el.removeEventListener("transitionend", handler);
        done();
      };
      el.addEventListener("transitionend", handler);
    },
    onBeforeEnter(el) {
      el.style.willChange = "height";
      el.style.height = "0";
      el.style.overflow = "hidden";
    },
    onEnter(el, done) {
      el.style.transition = TRANSITION;
      el.offsetHeight;
      el.style.height = `${el.scrollHeight}px`;
      this.onTransitionEnd(el, done);
    },
    onAfterEnter(el) {
      el.style.height = "";
      el.style.overflow = "";
      el.style.transition = "";
      el.style.willChange = "";
    },
    onBeforeLeave(el) {
      el.style.willChange = "height";
      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = "hidden";
    },
    onLeave(el, done) {
      el.style.transition = TRANSITION;
      el.offsetHeight;
      el.style.height = "0";
      this.onTransitionEnd(el, done);
    },
    onAfterLeave(el) {
      el.style.height = "";
      el.style.overflow = "";
      el.style.transition = "";
      el.style.willChange = "";
    },
  },
};
</script>
